import { Box, Paper, Text } from '@mantine/core';
import {
	AnalyticsEvent,
	AnalyticsEventType,
	AnalyticsJourney,
	AnalyticsStage
} from '@newo/analytics';
import { CircleCheck } from 'lucide-react';
import type { FC } from 'react';
import { useHostContext } from '@/context/HostContext.tsx';
import { StepperSetupStepKey } from '@/stepper/types.ts';
import { CLASS_NAMES } from '../../classNames';
import StepperSetupCompleteActions from '../StepperSetupCompleteActions';
import StepperSetupCompleteProfile from '../StepperSetupCompleteProfile';

interface StepperSetupCompleteActivationCardProps {
	agentName: string;
	agentPhoneNumber: string;
}

const StepperSetupCompleteActivationCard: FC<
	StepperSetupCompleteActivationCardProps
> = ({ agentName, agentPhoneNumber }) => {
	const { localization } = useHostContext();

	return (
		<Paper
			className={CLASS_NAMES.setupActivationCard}
			data-analytics-event={AnalyticsEvent.StepViewed}
			data-analytics-journey={AnalyticsJourney.CreatorSetup}
			data-analytics-stage={AnalyticsStage.CreatorOnboarding}
			data-analytics-step={StepperSetupStepKey.CallSummariesTransfers}
			data-analytics-type={AnalyticsEventType.Step}
			data-testid="stepper-setup-complete-activation-card"
			shadow="none"
		>
			<Box className={CLASS_NAMES.setupActivationContent}>
				<Box className={CLASS_NAMES.setupActivationCopy}>
					<Box className={CLASS_NAMES.setupActivationHeader}>
						<CircleCheck
							aria-hidden="true"
							className={CLASS_NAMES.setupActivationCheckIcon}
						/>
						<Text className={CLASS_NAMES.setupActivationTitle}>
							{localization.translate(
								'creator',
								'stepperOnboarding.setupComplete.activation.title'
							)}
						</Text>
					</Box>
					<Text className={CLASS_NAMES.setupActivationDescription}>
						{localization.translate(
							'creator',
							'stepperOnboarding.setupComplete.activation.descriptionPrefix'
						)}
					</Text>
				</Box>

				<StepperSetupCompleteActions />

				<Text className={CLASS_NAMES.setupActivationDescription}>
					{localization.translate(
						'creator',
						'stepperOnboarding.setupComplete.activation.descriptionSuffix'
					)}
				</Text>
			</Box>

			<StepperSetupCompleteProfile
				agentName={agentName}
				agentPhoneNumber={agentPhoneNumber}
			/>
		</Paper>
	);
};

export default StepperSetupCompleteActivationCard;
